import { IFiltersList } from "@/src/types/applicationOnline";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TasksFiltersState {
  actualOfficeTable: string;
  filterStatus: string;
  searchQuery: string;
  filterParams: IFiltersList | null;
  filterResults: Record<string, string[] | string | null>;
}

const initialState: TasksFiltersState = {
  actualOfficeTable: "ALL",
  filterStatus: "All",
  searchQuery: "",
  filterParams: null,
  filterResults: {},
};

const tasksFiltersSlice = createSlice({
  name: "tasksFilters",
  initialState,
  reducers: {
    setActualOfficeTable(state, action: PayloadAction<string>) {
      state.actualOfficeTable = action.payload;
    },
    setFilterStatus(state, action: PayloadAction<string>) {
      state.filterStatus = action.payload;
      switch (action.payload) {
        case "New":
          state.filterResults = { ...state.filterResults, status: ["new"] };
          break;
        case "In Proccess":
          state.filterResults = { ...state.filterResults, status: ["in_process"] };
          break;
        case "Document Check":
          state.filterResults = { ...state.filterResults, status: ["document_check"] };
          break;
        case "Done":
          state.filterResults = { ...state.filterResults, status: ["done"] };
          break;
        case "Rejected":
          state.filterResults = { ...state.filterResults, status: ["rejected"] };
          break;
        default:
          state.filterResults = { ...state.filterResults, status: null };
          break;
      }
    },
    setSearchQuery(state, action: PayloadAction<string>) {
      state.searchQuery = action.payload;
      state.filterResults = {
        ...state.filterResults,
        query: state.searchQuery,
      };
    },
    setFilterResults(state, action: PayloadAction<Record<string, string[] | string | null>>) {
      state.filterResults = action.payload;
    },
    updateFilterResult(state, action: PayloadAction<{ key: string; value: string[] | string | null }>) {
      state.filterResults = {
        ...state.filterResults,
        [action.payload.key]: action.payload.value,
      };
    },
  },
});

export const { setActualOfficeTable, setSearchQuery, setFilterStatus, setFilterResults, updateFilterResult } =
  tasksFiltersSlice.actions;

export default tasksFiltersSlice.reducer;
